import React from 'react';
import { cn } from '../../utils/cn';
interface AuroraBackgroundProps {
  className?: string;
  showRadialGradient?: boolean;
}
export function AuroraBackground({
  className,
  showRadialGradient = true
}: AuroraBackgroundProps) {
  return <div className={cn('absolute inset-0 overflow-hidden pointer-events-none', className)} aria-hidden="true" data-id="element-559">
      <div className={cn(`[--aurora:repeating-linear-gradient(100deg,var(--aurora-1)_10%,var(--aurora-2)_15%,var(--aurora-3)_20%,var(--aurora-4)_25%,var(--aurora-5)_30%)]
          [--dark-gradient:repeating-linear-gradient(100deg,var(--aurora-bg)_0%,var(--aurora-bg)_7%,var(--transparent)_10%,var(--transparent)_12%,var(--aurora-bg)_16%)]
          [background-image:var(--dark-gradient),var(--aurora)]
          [background-size:300%,_200%]
          [background-position:50%_50%,50%_50%]
          filter blur-[10px]
          after:content-[""] after:absolute after:inset-0
          after:[background-image:var(--dark-gradient),var(--aurora)]
          after:[background-size:200%,_100%]
          after:animate-aurora after:[background-attachment:fixed] after:mix-blend-difference
          absolute -inset-[10px] opacity-40 will-change-transform`, showRadialGradient && `[mask-image:radial-gradient(ellipse_at_100%_0%,black_10%,var(--transparent)_70%)]`)} data-id="element-560" />
    </div>;
}